import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { SiteConfigContext } from '../SiteConfigProvider'
import { Link } from '@jelly/ui'
import { oneOf } from 'prop-types'

// Styled Components via Emotion
const SocialButtonContainer = styled.div`
	display: flex;
	justify-content: space-between;
	max-width: 200px;
	margin: 20px 0;
	width: 100%;
`
const SocialMediaIcon = styled(Link)`
	svg {
		width: 30px;
		height: 30px;
	}
	line-height: 30px;
`

/**
 * This is the Social Media Component for BDC
 * It pulls our Facebook, LinkedIn, Twitter and Instagram icons
 * Each social media icon links to our corresponding BDC account
 * When a user hovers over one of the icons the SVG stroke and fill color should turn tertiary
 */
export function BDCSocialMediaGroup({ variant = 'primary' }) {
	const {
		siteComponents: { SOCIAL_MEDIA_GROUP_ICONS },
	} = useContext(SiteConfigContext)
	return (
		<SocialButtonContainer>
			{SOCIAL_MEDIA_GROUP_ICONS.map(({ label, slug, Svg }, i) => {
				return (
					<SocialMediaIcon aria-label={label} href={slug} key={i} rel="noopener noreferrer" target="_blank">
						<Svg variant={variant} />
					</SocialMediaIcon>
				)
			})}
		</SocialButtonContainer>
	)
}

BDCSocialMediaGroup.propTypes = {
	variant: oneOf(['primary', 'neutral', 'inverse']),
}
